import { createAction, props } from "@ngrx/store";

import { ShopStockRecord } from "./product-locator.state";

export const launchProductLocator = createAction(
    "[Product Locator] Launch ProductLocator feature",
    props<{ skus: string[] }>(),
);

export const fetchShopsStock = createAction(
    "[Product Locator] Fetch shops stock",
    props<{ skus: string[] }>(),
);

export const fetchShopsStockSuccess = createAction(
    "[Product Locator] Fetch shops stock success",
    props<{ shopsStock: ShopStockRecord }>(),
);

export const fetchShopsStockFailure = createAction(
    "[Product Locator] Fetch shops stock error",
    props<{ errorMessage: string }>(),
);

export const resetProductLocator = createAction(
    "[Product Locator] Reset Product Locator data",
);
